const workingHoursTypes = [
  {
    label: 'Автокран',
    value: 'truck_crane',
  },
  {
    label: 'Экскаватор',
    value: 'excavator',
  },
  {
    label: 'Бульдозер',
    value: 'dozer',
  },
  {
    label: 'Погрузчик',
    value: 'loader',
  },
  {
    label: 'Спецтехника (другое)',
    value: 'other_special',
  },
];

export default workingHoursTypes;
